"use client";
import AdminSidebar from "../../../components/AdminSidebar";
import { useState } from "react";
import { useRouter } from "next/navigation";

export default function NuevaReserva() {
  const router = useRouter();
  const [form, setForm] = useState({
    cliente:"", telefono:"", email:"",
    origen:"", destino:"",
    fecha:"", hora:"",
    asientos:"1", prioridad:"normal", notas:"",
    metodoPago:"tarjeta",
    cardName:"", cardNumber:"", cardExpiry:"", cardCvv:"",
    monto:"", priorityFee:"0",
  });
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");

  function upd(field:string, value:string) {
    setForm(f=>({...f,[field]:value}));
  }

  const priorityFees:any = { normal:"0", express:"5", priority:"10", vip_door:"20" };

  function calcTotal() {
    const base = parseFloat(form.monto||"0");
    const fee = parseFloat(priorityFees[form.prioridad]||"0");
    return (base + fee).toFixed(2);
  }

  async function guardar(e: React.FormEvent) {
    e.preventDefault();
    setGuardando(true);
    setError("");
    try {
      const fechaHora = form.fecha && form.hora ? `${form.fecha}T${form.hora}:00` : form.fecha;
      const res = await fetch("/api/reservas", {
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify({
          ...form,
          fecha: fechaHora,
          total: calcTotal(),
          priorityFee: priorityFees[form.prioridad],
        })
      });
      if (!res.ok) throw new Error("Error guardando reserva");
      router.push("/admin/reservas");
    } catch(err:any) {
      setError(err.message);
    } finally {
      setGuardando(false);
    }
  }

  return (
    <main style={{minHeight:"100vh",background:"#050b18",color:"#fff",fontFamily:"sans-serif"}}>
      <AdminSidebar />
      <section style={{marginLeft:"260px",padding:"40px",maxWidth:"900px"}}>
        <div style={{marginBottom:"28px"}}>
          <h1 style={{color:"#f5a623",fontSize:"28px",margin:0}}>Nueva Reserva</h1>
          <p style={{color:"#8ea0c4",marginTop:"6px",fontSize:"14px"}}>Registra una reserva manualmente</p>
        </div>

        {error && <div style={{background:"#2a0d0d",border:"1px solid #c0392b",borderRadius:"10px",padding:"12px 20px",marginBottom:"20px",color:"#e74c3c",fontSize:"14px"}}>{error}</div>}

        <form onSubmit={guardar}>

          {/* PASAJERO */}
          <Sec title="👤 Datos del Pasajero">
            <G2>
              <F label="Nombre completo *" value={form.cliente} onChange={(v:string)=>upd("cliente",v)} placeholder="María González" />
              <F label="Teléfono *" value={form.telefono} onChange={(v:string)=>upd("telefono",v)} placeholder="+1 (617) 555-0100" />
            </G2>
            <F label="Email" value={form.email} onChange={(v:string)=>upd("email",v)} placeholder="maria@email.com" />
          </Sec>

          {/* VIAJE */}
          <Sec title="🗺️ Detalles del Viaje">
            <G2>
              <F label="Origen *" value={form.origen} onChange={(v:string)=>upd("origen",v)} placeholder="Boston, MA" />
              <F label="Destino *" value={form.destino} onChange={(v:string)=>upd("destino",v)} placeholder="New York, NY" />
            </G2>
            <G2>
              <F label="Fecha *" value={form.fecha} onChange={(v:string)=>upd("fecha",v)} type="date" />
              <F label="Hora de salida" value={form.hora} onChange={(v:string)=>upd("hora",v)} type="time" />
            </G2>
            <G2>
              <F label="Número de asientos" value={form.asientos} onChange={(v:string)=>upd("asientos",v)} placeholder="1" />
              <Sel label="Nivel de prioridad" value={form.prioridad} onChange={(v:string)=>{upd("prioridad",v);}}
                opts={[
                  {v:"normal",   l:"Normal — sin cargo extra"},
                  {v:"express",  l:"Express +$5 — menos paradas"},
                  {v:"priority", l:"Priority +$10 — primera parada"},
                  {v:"vip_door", l:"VIP Door +$20 — puerta a puerta"},
                ]} />
            </G2>
          </Sec>

          {/* PAGO */}
          <Sec title="💳 Información de Pago">
            {/* Método */}
            <div>
              <label style={lbl}>Método de pago</label>
              <div style={{display:"flex",gap:"12px",marginTop:"8px"}}>
                {[
                  {v:"tarjeta", l:"💳 Tarjeta"},
                  {v:"efectivo", l:"💵 Efectivo"},
                  {v:"stripe_link", l:"🔗 Link Stripe"},
                ].map(m=>(
                  <button key={m.v} type="button" onClick={()=>upd("metodoPago",m.v)}
                    style={{padding:"10px 20px",borderRadius:"10px",border:`2px solid ${form.metodoPago===m.v?"#f5a623":"#1a2744"}`,
                      background:form.metodoPago===m.v?"#1a2744":"transparent",
                      color:form.metodoPago===m.v?"#f5a623":"#6677aa",cursor:"pointer",fontSize:"13px",fontWeight:form.metodoPago===m.v?800:400}}>
                    {m.l}
                  </button>
                ))}
              </div>
            </div>

            {/* Tarjeta */}
            {form.metodoPago==="tarjeta" && (
              <div style={{background:"#07111f",border:"1px solid #1a2744",borderRadius:"12px",padding:"20px",display:"flex",flexDirection:"column",gap:"14px"}}>
                <F label="Nombre en la tarjeta" value={form.cardName} onChange={(v:string)=>upd("cardName",v)} placeholder="MARIA GONZALEZ" />
                <F label="Número de tarjeta" value={form.cardNumber} onChange={(v:string)=>upd("cardNumber",v.replace(/\D/g,"").slice(0,16).replace(/(.{4})/g,"$1 ").trim())} placeholder="4242 4242 4242 4242" />
                <G2>
                  <F label="Fecha de expiración" value={form.cardExpiry} onChange={(v:string)=>upd("cardExpiry",v.replace(/\D/g,"").slice(0,4).replace(/(.{2})/,"$1/"))} placeholder="MM/YY" />
                  <F label="CVV" value={form.cardCvv} onChange={(v:string)=>upd("cardCvv",v.replace(/\D/g,"").slice(0,4))} placeholder="123" />
                </G2>
                <div style={{background:"#0a1628",borderRadius:"8px",padding:"10px 14px",fontSize:"12px",color:"#6677aa",display:"flex",gap:"8px",alignItems:"center"}}>
                  🔒 Datos almacenados de forma segura. Stripe procesará el cobro.
                </div>
              </div>
            )}

            {form.metodoPago==="efectivo" && (
              <div style={{background:"#07111f",border:"1px solid #1a3a2a",borderRadius:"12px",padding:"16px",color:"#2ecc71",fontSize:"13px"}}>
                💵 El pasajero pagará en efectivo al conductor al abordar.
              </div>
            )}

            {form.metodoPago==="stripe_link" && (
              <div style={{background:"#07111f",border:"1px solid #1a2744",borderRadius:"12px",padding:"16px",color:"#8ea0c4",fontSize:"13px"}}>
                🔗 Se generará un link de pago de Stripe y se enviará al pasajero por email/SMS.
              </div>
            )}

            {/* Resumen de cobro */}
            <div style={{background:"#07111f",border:"1px solid #1a2744",borderRadius:"12px",padding:"20px"}}>
              <div style={{fontSize:"12px",color:"#6677aa",marginBottom:"12px",letterSpacing:"0.08em",textTransform:"uppercase"}}>Resumen de cobro</div>
              <div style={{display:"flex",flexDirection:"column",gap:"8px"}}>
                <div style={{display:"flex",justifyContent:"space-between",fontSize:"14px",color:"#8ea0c4"}}>
                  <span>Precio base del viaje</span>
                  <div style={{display:"flex",alignItems:"center",gap:"8px"}}>
                    <span style={{color:"#334",fontSize:"12px"}}>$</span>
                    <input value={form.monto} onChange={e=>upd("monto",e.target.value)}
                      placeholder="0.00" style={{width:"80px",background:"#0a1628",border:"1px solid #24324d",borderRadius:"6px",padding:"4px 8px",color:"#fff",fontSize:"14px",outline:"none",textAlign:"right"}} />
                  </div>
                </div>
                {form.prioridad!=="normal" && (
                  <div style={{display:"flex",justifyContent:"space-between",fontSize:"14px",color:"#f5a623"}}>
                    <span>Priority fee ({form.prioridad})</span>
                    <span>+${priorityFees[form.prioridad]}</span>
                  </div>
                )}
                <div style={{borderTop:"1px solid #1a2744",paddingTop:"10px",marginTop:"4px",display:"flex",justifyContent:"space-between",fontSize:"16px",fontWeight:800,color:"#fff"}}>
                  <span>Total</span>
                  <span style={{color:"#f5a623"}}>${calcTotal()}</span>
                </div>
              </div>
            </div>
          </Sec>

          {/* NOTAS */}
          <Sec title="📝 Notas">
            <FA label="Notas internas (opcional)" value={form.notas} onChange={(v:string)=>upd("notas",v)} placeholder="Instrucciones especiales, equipaje, etc." />
          </Sec>

          <div style={{display:"flex",gap:"14px",marginTop:"8px"}}>
            <button type="submit" disabled={guardando}
              style={{background:"#f5a623",color:"#000",border:"none",padding:"14px 32px",borderRadius:"10px",fontWeight:800,cursor:"pointer",fontSize:"15px",opacity:guardando?0.7:1}}>
              {guardando?"Guardando...":"💾 Guardar Reserva"}
            </button>
            <button type="button" onClick={()=>router.push("/admin/reservas")}
              style={{background:"transparent",border:"1px solid #334",color:"#8ea0c4",padding:"14px 24px",borderRadius:"10px",cursor:"pointer",fontSize:"14px"}}>
              Cancelar
            </button>
          </div>
        </form>
      </section>
    </main>
  );
}

function Sec({title,children}:any) {
  return (
    <div style={{background:"#0f1d36",border:"1px solid #1a2744",borderRadius:"14px",padding:"24px",marginBottom:"20px"}}>
      <div style={{color:"#f5a623",fontWeight:700,fontSize:"13px",letterSpacing:"0.08em",textTransform:"uppercase",marginBottom:"18px",paddingBottom:"10px",borderBottom:"1px solid #1a2744"}}>{title}</div>
      <div style={{display:"flex",flexDirection:"column",gap:"14px"}}>{children}</div>
    </div>
  );
}
function G2({children}:any) {
  return <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"16px"}}>{children}</div>;
}
function F({label,value,onChange,placeholder,type}:any) {
  return (
    <div>
      <label style={{display:"block",fontSize:"11px",color:"#8ea0c4",marginBottom:"5px",letterSpacing:"0.08em",textTransform:"uppercase"}}>{label}</label>
      <input type={type||"text"} value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder}
        style={{width:"100%",padding:"11px 14px",borderRadius:"10px",border:"1px solid #24324d",background:"#07111f",color:"#fff",fontSize:"13px",outline:"none",boxSizing:"border-box"}} />
    </div>
  );
}
function FA({label,value,onChange,placeholder}:any) {
  return (
    <div>
      <label style={{display:"block",fontSize:"11px",color:"#8ea0c4",marginBottom:"5px",letterSpacing:"0.08em",textTransform:"uppercase"}}>{label}</label>
      <textarea value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder} rows={3}
        style={{width:"100%",padding:"11px 14px",borderRadius:"10px",border:"1px solid #24324d",background:"#07111f",color:"#fff",fontSize:"13px",outline:"none",resize:"vertical",fontFamily:"sans-serif",boxSizing:"border-box"}} />
    </div>
  );
}
function Sel({label,value,onChange,opts}:any) {
  return (
    <div>
      <label style={{display:"block",fontSize:"11px",color:"#8ea0c4",marginBottom:"5px",letterSpacing:"0.08em",textTransform:"uppercase"}}>{label}</label>
      <select value={value} onChange={e=>onChange(e.target.value)}
        style={{width:"100%",padding:"11px 14px",borderRadius:"10px",border:"1px solid #24324d",background:"#07111f",color:"#fff",fontSize:"13px",outline:"none"}}>
        {opts.map((o:any)=><option key={o.v} value={o.v}>{o.l}</option>)}
      </select>
    </div>
  );
}
const lbl:any={display:"block",fontSize:"11px",color:"#8ea0c4",marginBottom:"5px",letterSpacing:"0.08em",textTransform:"uppercase"};
